<ion-list mode="ios" lines="none" class="list-content">
  <!-- * Titulo -->
  <ion-item mode="md" lines="none" color="white">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 cancel-account"
    >
      {{ 'Titles.cancel-account' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Descripción -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label mode="md" class="confirm-cancel-account">
      <ion-text mode="md" color="grayDemon">
        {{ 'Labels.confirm-cancel-account' | translate }}
      </ion-text>
      <br />
      <ion-text mode="md" color="danger">
        {{ 'Labels.action-cannot-reversed' | translate }}
      </ion-text>
    </ion-label>
  </ion-item>

  <!-- * Botones -->
  <ion-item mode="md" lines="none" color="white">
    <ng-container *ngIf="!loading">
      <ion-button
        class="buttons"
        size="default"
        mode="md"
        color="white"
        slot="start"
        (click)="onClose(true)"
      >
        <ion-label mode="md" color="tpcta">
          {{ 'Buttons.cancel-account' | translate }}
        </ion-label>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="loading">
      <ion-button
        class="buttons"
        size="default"
        mode="md"
        color="white"
        slot="start"
        disabled
      >
        <ion-spinner color="tpcta" name="crescent"></ion-spinner>
        <ion-label mode="md" color="tpcta">
          {{ 'Buttons.cancel-account' | translate }}
        </ion-label>
      </ion-button>
    </ng-container>

    <ion-button
      class="buttons"
      size="default"
      mode="md"
      color="tpcta"
      slot="end"
      [disabled]="loading"
      (click)="onClose(false)"
    >
      <ion-label mode="md" color="white">
        {{ 'Buttons.return' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
